import { Controller } from "@hotwired/stimulus"
import * as Turbo from "@hotwired/turbo"

// Navigates to the URL stored in the selected option's value.
// Usage: data-controller="navigate-select" data-action="change->navigate-select#navigate"
export default class extends Controller {
  navigate() {
    const url = this.element.value
    if (url) Turbo.visit(url)
  }

  back() {
    history.back()
  }
}
